// @flow
import React from 'react'
import renderHTML from 'react-render-html'
import { Icon } from 'semantic-ui-react'
import './styles.scss'

export default class Drawer extends React.Component<Props, State> {
  constructor() {
    super()
    this.state = {
      isActive: false,
      isMobile: window.innerWidth < 650,
      isTablet: window.innerWidth < 800
    }
    this.handleClick = this.handleClick.bind(this)
  }

  handleClick() {
    console.log('handle click')
    this.setState({ isActive: !this.state.isActive })
  }

  render() {
    return (
      <div className={this.state.isActive ? 'drawer active' : 'drawer'}>
        <div
          className='header'
          active={this.state.isActive}
          onClick={this.handleClick}
        >
          <div className='title'>{renderHTML(this.props.title)}</div>
          <div className='arrow'>
            <Icon name={this.state.isActive ? 'close small' : 'angle down'} />
          </div>
        </div>
        <div className='content' active={this.state.isActive}>
          {this.props.children}
        </div>
      </div>
    )
  }
}
